import Header from "components/Headers/Header";
import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { deleterequestcities } from "store/actions/requestCitiesAction";
import { datachange } from "store/actions/requestCitiesAction";
import { toast } from "react-toastify";
import {
  Container,
  Button,
  Table,
  Modal,
  ModalBody,
  Card,
  CardBody,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import { getAllUsers } from "store/actions/usersActions";
import { getRequestCities } from "store/actions/requestCitiesAction";
import TableComponent from "components/TableComponent";
import ConfirmationModal from "components/Modal/ConfirmationModal";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const RequestCities = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false); //Modal For Show Position
  const [localCitiesData, setLocalCitiesData] = useState([]);
  const [supporter, setSupporter] = useState();
  const {
    requestCitiesData,
    lastDoc,
    isFetchingRequestCities,
    hasMoreRequestCities,
  } = useSelector((state) => state.requestcities);
  const { allUsers } = useSelector((state) => state.users);
  const [loader, setLoader] = useState({
    data: false,
  });

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    action: "",
    data: null,
    message: "",
  });

  const infoPoints = [
    "The admin can accept or reject city requests submitted by athletes and fans. Additionally, the admin can track whether the request was initiated by an athlete or a fan.",
  ];
  const subPoints = [];
  const infoTitle = "City Request Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  useEffect(() => {
    if (requestCitiesData) {
      setLocalCitiesData(requestCitiesData);
    }
  }, [requestCitiesData]);

  const handleLoadMore = () => {
    if (hasMoreRequestCities && !isFetchingRequestCities) {
      dispatch(getRequestCities(lastDoc));
    }
  };

  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getRequestCities(null, () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);

  useEffect(() => {
    if (allUsers.length == 0) {
      dispatch(getAllUsers());
    }
  }, []);

  const deletedata = (id) => {
    setLoader((prev) => ({
      ...prev,
      action: true,
    }));

    dispatch(
      deleterequestcities(id, () => {
        // Update local state to remove the item
        setLocalCitiesData((prevData) =>
          prevData.filter((item) => item.id !== id)
        );

        setLoader((prev) => ({
          ...prev,
          action: false,
        }));
        toast.success("Request rejected successfully");
        toggleConfirmModal();
      })
    );
  };

  const datachangerequest = (city, state, college, DocID) => {    setLoader((prev) => ({
      ...prev,
      action: true,
    }));

    let obj = {
      city: city,
      state: state,
      institutes: [college],
    };

    dispatch(
      datachange(obj, DocID, () => {
        setLocalCitiesData((prevData) => {
          return prevData.some((item) => item.id === DocID)
            ? prevData.filter((item) => item.id !== DocID)
            : prevData;
        });
        setLoader((prev) => ({
          ...prev,
          action: false,
        }));
        toast.success("request accept successfully");
        setTimeout(() => {
          toggleConfirmModal();
        }, 200);
      })
    );
  };

  const handleModal = () => {
    setIsModalOpen(false);
  };

  const getPlayerName = (ID) => {
    var obj =
      allUsers &&
      allUsers.find((ele) => {
        return ele.id == ID;
      });
    if (obj) {
      if (obj.role == "athlete") {
        return obj.first_name + " " + obj.last_name;
      } else if (obj.role == "fan") {
        return obj.name;
      }
    } else {
      return "N/A";
    }
  };

  const handleSupportByName = (arr) => {
    setSupporter(arr);
    setIsModalOpen(true);
  };

  const toggleConfirmModal = () => {
    setConfirmModal({
      isOpen: false,
      action: "",
      data: null,
      message: "",
    });
    setLoader((prev) => ({
      ...prev,
      action: false,
    }));
    // setConfirmModal(prev => ({
    //   ...prev,
    //   isOpen: !prev.isOpen,
    //   ...(prev.isOpen && { action: "" })
    // }));
  };

  const handleAcceptConfirm = (city, state, college, id) => {
    setConfirmModal({
      isOpen: true,
      action: "accept",
      data: { city, state, college, id },
      message: "You want to Accept Request.",
    });
  };

  // Handle reject request confirmation
  const handleRejectConfirm = (id) => {
    setConfirmModal({
      isOpen: true,
      action: "reject",
      data: { id },
      message: "You want to Reject Request.",
    });
  };

  // Handle confirmation
  const handleConfirm = () => {
    if (confirmModal.action === "accept") {
      const { city, state, college, id } = confirmModal.data;
      datachangerequest(city, state, college, id);
    } else if (confirmModal.action === "reject") {
      const { id } = confirmModal.data;
      deletedata(id);
    }
    setTimeout(() => {
      toggleConfirmModal();
    }, 200);
  };
  // Table configuration for the main requests table
  const columns = [
    "State",
    "City",
    "My College Name",
    "My College's Sports",
    "Added By",
    "Support",
    "Support By",
  ];

  const keyMap = {
    State: "state",
    City: "city",
    "My College Name": "college",
    "My College's Sports": "sport",
    "Added By": "added_by_name",
    Support: "supportDisplay",
    "Support By": "supportByIcon",
    // "Action": "actions"
  };

  const preparedData = localCitiesData?.map((item) => ({
    ...item,
    added_by_name: getPlayerName(item.added_by),
    supportDisplay: (
      <div className="d-flex justify-content-center pt-2">
        <i className="fas fa-heart fa-2x text-danger"></i>
        <p className="pl-2">{item.support}</p>
      </div>
    ),
    supportByIcon: (
      <i
        className="fas fa-eye fa-2x pointer"
        onClick={() => handleSupportByName(item.supported_by)}
      ></i>
    ),
  }));

  const renderActions = (row) => {
    if (row.status === "pending") {
      return (
        <>
          <Button
            size="sm"
            color="primary"
            onClick={() => {
              handleAcceptConfirm(row.city, row.state, row.college, row.id);
            }}
            // onClick={(e) => {
            //   datachangerequest(
            //     e,
            //     row.city,
            //     row.state,
            //     row.college,
            //     row.id
            //   );
            // }}
          >
            Accept
          </Button>
          <Button
            size="sm"
            color="danger"
            onClick={() => {
              handleRejectConfirm(row.id);
            }}
          >
            Reject
          </Button>
        </>
      );
    } else {
      return row.status;
    }
  };

  const supporterColumns = ["Supporter Names"];
  const supporterKeyMap = {
    "Supporter Names": "name",
  };
  const supporterData = supporter?.map((id) => ({
    name: getPlayerName(id),
  }));

  return (
    <>
      <Header />
      <Container fluid className="my-4">
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        {requestCitiesData?.length > 0 ? (
          <Card className="p-2">
            {/* <h2 className="px-3 mt-3">City Requests</h2> */}
            <Row>
              <Col sm="12">
                {loader.data ? (
                  <div className="text-center mt-4">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <>
                    <TableComponent
                      columns={columns}
                      data={preparedData}
                      keyMap={keyMap}
                      renderActions={renderActions}
                    />
                    {/* <Table
                      className="align-items-center table-flush mt-4"
                      responsive
                    >
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            className="custom-table-heading custom-heading"
                          >
                            State
                          </th>
                          <th
                            scope="col"
                            className="custom-table-heading custom-heading text-center"
                          >
                            City
                          </th>
                          <th
                            scope="col"
                            className="custom-table-heading custom-heading text-center"
                          >
                            My College Name
                          </th>
                          <th
                            scope="col"
                            className="custom-table-heading custom-heading text-center"
                          >
                            My College’s Sports
                          </th>
                          <th
                            scope="col"
                            className="custom-table-heading custom-heading text-center"
                          >
                            Added By
                          </th>
                          <th
                            scope="col"
                            className="custom-table-heading custom-heading text-center"
                          >
                            Support
                          </th>
                          <th
                            scope="col"
                            className="custom-table-heading custom-heading text-center"
                          >
                            Support By
                          </th>
                          <th
                            scope="col"
                            className="custom-table-heading custom-heading text-center"
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="mt-3" style={{ background: "white" }}>
                        {requestCitiesData?.map((requestCityData) => {
                          return (
                            <tr>
                              <td className="custom-table-text">
                                {requestCityData.state}
                              </td>
                              <td className="custom-table-text" align="center">
                                {requestCityData.city}
                              </td>
                              <td className="custom-table-text" align="center">
                                {requestCityData.college}
                              </td>
                              <td className="custom-table-text" align="center">
                                {requestCityData.sport}
                              </td>
                              <td className="custom-table-text" align="center">
                                {getPlayerName(requestCityData.added_by)}
                              </td>
                              <td className="custom-table-text" align="center">
                                <div className="d-flex justify-content-center pt-2">
                                  <i className="fas fa-heart fa-2x text-danger"></i>
                                  <p className="pl-2">
                                    {requestCityData.support}
                                  </p>
                                </div>
                              </td>
                              <td className="custom-table-text" align="center">
                                <i
                                  className="fas fa-eye fa-2x pointer"
                                  onClick={() =>
                                    handleSupportByName(
                                      requestCityData.supported_by
                                    )
                                  }
                                ></i>
                              </td>
                              <td className="custom-table-text">
                                {requestCityData.status === "pending" ? (
                                  <>
                                    <Button
                                      size="sm"
                                      color="primary"
                                      onClick={(e) => {
                                        datachangerequest(
                                          e,
                                          requestCityData.city,
                                          requestCityData.state,
                                          requestCityData.college,
                                          requestCityData.id
                                        );
                                      }}
                                    >
                                      Accept
                                    </Button>
                                    <Button
                                      size="sm"
                                      color="danger"
                                      onClick={(e) => {
                                        deletedata(e, requestCityData.id);
                                      }}
                                    >
                                      Reject
                                    </Button>
                                  </>
                                ) : (
                                  requestCityData.status
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table> */}
                    {requestCitiesData?.length > 4 && (
                      <div className="text-center my-4">
                        <Button
                          onClick={handleLoadMore}
                          disabled={
                            isFetchingRequestCities || !hasMoreRequestCities
                          }
                          color="primary"
                        >
                          {isFetchingRequestCities ? (
                            <Spinner size="sm" />
                          ) : (
                            "Load More"
                          )}
                        </Button>
                      </div>
                    )}
                  </>
                )}
              </Col>
            </Row>
          </Card>
        ) : (
          <Card className="filter-card mt-3">
            <CardBody className="bg-danger text-center rounded">
              <h2 className="text-white">
                <i className="fa fa-exclamation-triangle mr-3"></i> No Requests
                Submitted Yet.
              </h2>
            </CardBody>
          </Card>
        )}
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
      <Modal isOpen={isModalOpen}>
        <ModalBody>
          {supporter && supporter.length > 0 ? (
            <TableComponent
              columns={supporterColumns}
              data={supporterData}
              keyMap={supporterKeyMap}
            />
          ) : (
            <Card className="filter-card mt-3">
              <CardBody className="bg-danger text-center rounded">
                <h3 className="text-white">
                  <i className="fa fa-exclamation-triangle mr-3"></i> No
                  Supporter Yet.
                </h3>
              </CardBody>
            </Card>
          )}
          {/* <Table className="align-items-center table-flush" responsive>
            <thead>
              <tr>
                <th scope="col" className="custom-table-heading custom-heading">
                  Supporter Names
                </th>
              </tr>
            </thead>
            <tbody className="mt-3" style={{ background: "white" }}>
              {supporter && supporter.length > 0 ? (
                supporter.map((ele, index) => (
                  <tr>
                    <td className={"custom-table-text"}>
                      {getPlayerName(ele)}
                    </td>
                  </tr>
                ))
              ) : (
                <Card className="filter-card mt-3">
                  <CardBody className="bg-danger text-center rounded">
                    <h3 className="text-white">
                      <i className="fa fa-exclamation-triangle mr-3"></i> No
                      Supporter Yet.
                    </h3>
                  </CardBody>
                </Card>
              )}
            </tbody>
          </Table> */}
          <div className="text-right">
            <Button className="mt-4" color="danger" onClick={handleModal}>
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <ConfirmationModal
        isOpen={confirmModal.isOpen}
        toggle={toggleConfirmModal}
        onConfirm={handleConfirm}
        isLoading={loader.action}
        title="Confirmation"
        message={confirmModal.message}
      />
    </>
  );
};

export default RequestCities;
